import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { ExclusionListSelectorWebComponentSchema } from '../types';
import { ErrorDialogStrings } from '../../../types';
import { translateFn } from '../../../utils/translator.helper';

export class ExclusionListSelectorView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$exclusionListSelectorDropdown = this.shadow.querySelector('#exclusionListSelectorDropdown');
    this.setTranslatedStrings();
  }

  setTranslatedStrings() {
    this.dom.$exclusionListSelectorDropdown.setAttribute('noResultsFound', this.commonStrings.noResultsFound);
    this.dom.$exclusionListSelectorDropdown.setAttribute('errorMessage', this.commonStrings.genericError);
  }

  buildSuccessView(data: ExclusionListSelectorWebComponentSchema) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }

    this.createDropdown(data);
  }

  createDropdown(data) {
    const { disabled, selectedTarget, list } = data;
    this.dom.$exclusionListSelectorDropdown.disabled = disabled;
    const ExclusionListOptions = list.map((availableExclusionList, index) => {
      return {
        label: availableExclusionList.label,
        value: index, //availableExclusionList.value,
        selected: selectedTarget.indexOf(availableExclusionList.value) >= 0,
      };
    });

    this.dom.$exclusionListSelectorDropdown.setAttribute('filterOptions', JSON.stringify(ExclusionListOptions));
    this.dom.$exclusionListSelectorDropdown.setAttribute('value', selectedTarget.value || '');

    this.dom.$exclusionListSelectorDropdown.setAttribute('label', 'Exclusion lists');
    this.dom.$exclusionListSelectorDropdown.setAttribute('labelWidth', '240');
    this.dom.$exclusionListSelectorDropdown.setAttribute('searchPlaceholderString', 'Search filter');
    this.dom.$exclusionListSelectorDropdown.setAttribute('confirmActionButtonString', 'Apply');
    this.dom.$exclusionListSelectorDropdown.setAttribute('noSearchResultsString', 'No results found');
    this.dom.$exclusionListSelectorDropdown.setAttribute('listTitle', 'All');
    this.dom.$exclusionListSelectorDropdown.allowSelectNone = true;
  }

  clearInput() {
    this.dom.$exclusionListSelectorDropdown.clearInput();
  }

  public showErrorDialog(ExclusionListName: string) {
    const dialogStrings = this.stringsTranslator.getDialogStrings();
    const { loadingErrorTitle, genericErrorMessage, confirm } = dialogStrings;
    const message = ExclusionListName
      ? this.getExclusionListNameInSelectorErrorMessage(ExclusionListName)
      : genericErrorMessage;

    const strings: ErrorDialogStrings = {
      title: loadingErrorTitle,
      message: message,
      actionButtonString: confirm,
    };

    this.buildDialogElement(strings);
  }

  private getExclusionListNameInSelectorErrorMessage(ExclusionListName: string): string {
    return translateFn(
      'An internal error occurred when selecting the ExclusionList {name}. Please try again later or contact Bitdefender Enterprise Support if the issue persists.',
      {
        name: ExclusionListName,
      }
    );
  }
}
